export default {
  state: {
    onairDescriptions: {},
  },
  mutations: {
    createOnairDescription(state, { descriptionType, description }) {
      state.onairDescriptions[descriptionType] = description || '';
    },
    updateOnairDescription(state, { descriptionType, description }) {
      state.onairDescriptions[descriptionType] = description;
    },
  },
};
